import React, {useContext} from 'react';
import { Link } from 'react-router-dom';
import styles from "./Navbar.module.scss";
import { Context } from '../Store';
import logo from "../../imgs/myCashLogo.png";
import NavLinks from './NavLinks';
import FooterLink from './FooterLink';




const Navbar = () => {
    let{dir,translate,handleClick,isClicked,scrollToSection,homeSection,startSection,clickBtn,clickbtns} = useContext(Context);
    let{btn0} = translate.navbar;

  return (
    <>
    <nav id={styles.navbar} 
    // className={fix?`${styles.fixedNav}`:""}
    >
        <div className={styles.container}>
                <Link to="" className={styles.logo}  onClick={()=>scrollToSection(homeSection)}><img  src={logo} alt="" />
                </Link>
            <ul
            id={dir==="ltr"?styles.linksLtr:styles.linksRtl}
             className={isClicked&&dir==="ltr"?`${styles.links} ${styles.activeLtr}`:
             isClicked&&dir==="rtl"?`${styles.links} ${styles.activeRtl}`:`${styles.links}`}>
                <NavLinks/>
                <Link to="start" onClick={()=>scrollToSection(startSection)} className={styles.link}> <button onClick={()=>clickBtn("startExp",70)} className={clickbtns==="startExp"?"clickBtns":""} id={dir==="ltr"?styles.btnLtr:""}>{dir==="ltr"?btn0[0]:btn0[1]}</button></Link>
                <FooterLink/>
            </ul>
                <div id={styles.mobile} onClick={handleClick}>
                    <i id={styles.bar} className={isClicked?"fas fa-times":"fas fa-bars"}></i>
                </div>
        </div>
    </nav>
    
    </>
    
  )
}

export default Navbar;